// import { clearInterval } from 'timers';
import DrawerItem from './parts/DrawerItem.vue';
import {clickOutside} from '@/directives/clickOutside';
// import { mapState } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';
import user_module from '@/modules/user/index';
import VTooltip from 'v-tooltip';
import Draggable from 'vuedraggable';
Vue.use(VTooltip)

@Component({

  components: {
    DrawerItem,
    Draggable
  },

  directives: {
    outside: clickOutside,
  }
})

export default class Drawer extends Vue {

  @Prop({default: 150}) drawerMaxWidth!: number;
  user: {avatar: string} = {
    avatar: require('@/assets/icons/rixtrema.jpg')
  }
  expand = false;
  drawerItemIconSize: string = 'fa-2x'
  displayUserName: string = 'flex'
  avatarRotateDeg: number = 0
  drawerMinWidth: number = 55
  drawerWidth: number = 55
  collapsed: boolean = true

  dragStart(drag: any){

    console.log('start', drag)
  }

  dragEnd(drag: any){

    console.log('end', drag)
  }

  getTooltip(content: string){

    return {content: !this.expand ? content : '', classes: 'tooltip'}

  }

  openNoti(){

    user_module.toggleNoti(true);
  }

  changeDrawer(){

    if (this.collapsed){

      this.onExpandClick();

    } else {

      this.onCollapseClick()
    }

  }

  onCollapseClick() {

    this.collapsed = true;
    this.$emit('collapse');
    this.setTextLabelsHidde(true);
    this.drawerItemIconSize="fa-2x";
    this.doCollapseDrawer();

  }

  onExpandClick() {

    this.collapsed = false;
    this.$emit('expand');
    this.drawerItemIconSize="fa-1x";
    this.setTextLabelsHidde(false);
    this.doExpandDrawer();

  }

  doExpandDrawer() {
    const me = this,
    widthStep = 5,
    collapseIntervalId = setInterval(function() {
      if(me.drawerWidth < me.drawerMaxWidth ) {
        me.drawerWidth += widthStep;
      } else {
        window.clearInterval(collapseIntervalId);
        me.drawerWidth = me.drawerMaxWidth;
        me.$emit('expand');
      }
    }, 1);
  }

  doCollapseDrawer() {
    var me = this,
        widthStep = 5,
        collapseIntervalId = setInterval(function() {
          if(me.drawerWidth > me.drawerMinWidth ) {
            me.drawerWidth -= widthStep;
          } else {
            window.clearInterval(collapseIntervalId);
            me.drawerWidth = me.drawerMinWidth;
            me.$emit('collapse');
          }
        }, 1);
  }

  setTextLabelsHidde(expand: boolean) {

    var cssValue = (expand ? 'none': 'flex');
    this.expand = !expand;
    this.displayUserName = cssValue;
    
  }

  
  get sites(){

    return user_module.userProducts.filter(product => product.bought && !product.hide);

  }

  set sites(sites){

    user_module.setSortedProducts(sites.map(site => site.id));

    console.log('value', sites);
  }

  get currentRouteName() {
    return this.$route.name
  }


}
